import { render, staticRenderFns } from "./rebeta.vue?vue&type=template&id=44b026ca&scoped=true&"
import script from "./rebeta.vue?vue&type=script&lang=js&"
export * from "./rebeta.vue?vue&type=script&lang=js&"
import style0 from "@/sass/rebeta.scss?vue&type=style&index=0&id=44b026ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b026ca",
  null
  
)

export default component.exports